<script lang="ts">
    import { onMount } from 'svelte'
    import type { QuotationEntity } from '../../../modules/posApi/quotation/quotation.entity'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import dayjs from 'dayjs'

    export let shared = false
    export let quotation: QuotationEntity = null

    let gridCustomer: GridClass = new GridClass()
    function loadGridCustomer() {
        // grid
        gridCustomer = new GridClass()
        // grid head
        gridCustomer.title = 'Dados do cliente'
        gridCustomer.subtitle = ''
        gridCustomer.cols.push(new GridCol({ content: 'Cliente' }))
        gridCustomer.cols.push(new GridCol({ content: 'Documento', size: 3 }))
        gridCustomer.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone, size: 3 }))
        // grid lines
        let line: GridLine = new GridLine()
        line.slots.push({ content: quotation.person?.name })
        line.slots.push({ content: quotation.person?.document })
        line.slots.push({ content: quotation.person?.phone })
        gridCustomer.lines.push(line)
    }

    let gridItems: GridClass = new GridClass()
    function loadGridItems() {
        // grid
        gridItems = new GridClass()
        // grid head
        gridItems.title = 'Itens no orçamento'
        gridItems.subtitle = ''
        gridItems.cols.push(new GridCol({ content: 'Item' }))
        gridItems.cols.push(new GridCol({ content: 'Qtde', type: GridColTypeEnum.int }))
        gridItems.cols.push(new GridCol({ content: 'Valor unit.', type: GridColTypeEnum.float_2 }))
        gridItems.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.float_2, showTotal: true }))
        // grid lines
        for (const item of quotation.items) {
            let line: GridLine = new GridLine()
            if (item.parentServiceId) {
                line.slots.push({ content: ' - ' + item.service?.name })
            } else {
                line.slots.push({ content: item.service?.name })
            }
            if (item.type === 'package') {
                line.slots.push({ content: null })
                line.slots.push({ content: null })
                line.slots.push({ content: null })
            } else {
                line.slots.push({ content: item.quantity })
                line.slots.push({ content: item.value })
                line.slots.push({ content: item.value * item.quantity })
            }
            gridItems.lines.push(line)
        }
    }

    function getPrep(method: string) {
        if (method === 'Dinheiro') return 'em'
        if (method === 'Pix') return 'por'
        if (method === 'Financeira') return 'via'
        if (method === 'Outros*') return 'via'
        return 'no'
    }

    function friendlyInstallment(item) {
        if (item.installmentFrom === item.installmentTo) {
            if (item.installmentFrom === 1) {
                return 'em 1 vez'
            } else {
                return 'em ' + item.installmentFrom + ' vezes'
            }
        }
        if (item.installmentFrom === 1) {
            return 'em até ' + item.installmentTo + ' vezes'
        }
        return 'de ' + item.installmentFrom + ' a ' + item.installmentTo + ' vezes'
    }
    let gridPayment: GridClass = new GridClass()
    function loadGridPayment() {
        // grid
        gridPayment = new GridClass()
        // grid head
        gridPayment.title = 'Opções de pagamento'
        gridPayment.subtitle = ''
        gridPayment.cols.push(new GridCol({ content: 'Entrada' }))
        gridPayment.cols.push(new GridCol({ content: 'Parcelamento' }))
        gridPayment.cols.push(new GridCol({ content: 'Total', type: GridColTypeEnum.float_2 }))
        // grid lines
        for (const item of quotation.payments) {
            let line: GridLine = new GridLine()
            let dp = item.dpValue ? item.dpValue.toFixed(2) + ' ' + getPrep(item.dpMethod) + ' ' + item.dpMethod.toLowerCase() : 'sem entrada'
            let inst =
                item.installmentValue.toFixed(2) +
                ' ' +
                getPrep(item.installmentMethod) +
                ' ' +
                item.installmentMethod.toLowerCase() +
                ' ' +
                friendlyInstallment(item)
            let total = item.installmentValue + item.dpValue
            line.slots.push({ content: dp })
            line.slots.push({ content: inst })
            line.slots.push({ content: total })
            gridPayment.lines.push(line)
        }
    }
    onMount(async () => {
        await loadGridCustomer()
        await loadGridItems()
        await loadGridPayment()
    })

    function getExpiration() {
        const expiresAt = new Date(quotation.createdAt)
        expiresAt.setDate(expiresAt.getDate() + quotation.expiresAt)
        return 'Este orçamento é válido até ' + dayjs(expiresAt).format('DD/MM/YYYY')
    }
</script>

{#if quotation}
    <div class="qp">
        <div class="qp_body">
            <div class="qp_title">Orçamento</div>
            <Zgrid class="h-space" grid={gridCustomer} {shared}></Zgrid>
            <Zgrid class="h-space" grid={gridItems} {shared}></Zgrid>
            <Zgrid class="h-space" grid={gridPayment} {shared}></Zgrid>

            <Zframe title="Observações" class="h-space">
                <div class="notes_p">{quotation.notes}</div>
                <div class="notes_p">{getExpiration()}</div>
            </Zframe>
        </div>
    </div>
{/if}

<style>
    .qp {
        height: 100% !important;
        font-family: 'Nunito';
    }
    .qp_title {
        font-size: 26px;
    }

    .quotation_print {
    }
    .quotation_print .qp_body {
    }
    .qp_title {
        text-align: center;
    }
    .qp_body {
        position: relative;
        height: 100% !important;
        font-size: 16px;
    }
    .qp_item {
        display: flex;
    }
    .qp_item > * {
        flex-grow: 1;
    }
    .qp_item_bold {
        font-weight: bold;
        font-size: 18px;
    }

    .notes_p {
        white-space: pre-wrap;
        margin-top: 16px;
    }
</style>
